export const BASE_SURVEY_PATH = '/surveys';

export const INDEX_SURVEY_PATH = `${ BASE_SURVEY_PATH }/all`;
export const NEW_SURVEY_PATH = `${ BASE_SURVEY_PATH }/new`;
export const EDIT_SURVEY_PATH = `${ BASE_SURVEY_PATH }/edit/:id`;
